export const SET_ROOM_PASSWORD = 'SET_ROOM_PASSWORD';
export const SET_ROOM_LOCKED = 'SET_ROOM_LOCKED';
export const TOGGLE_E2EE = 'TOGGLE_E2EE';
